var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorPortfolio03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C25443;}\n\t.st1{fill:#AE4B3C;}\n\t.st2{opacity:0.25;fill:#FFFFFF;}\n\t.st3{fill:none;}\n\t.st4{fill:#D0D2D3;}\n\t.st5{fill:#BBBDBD;}\n\t.st6{fill:#E6E7E8;}\n\t.st7{fill:#2D2D2E;}\n\t.st8{fill:#C3996B;}\n\t.st9{fill:#AF8960;}\n\t.st10{fill:#603813;}\n\t.st11{fill:#A87C4F;}\n\t.st12{fill:none;stroke:#8A5D3B;stroke-width:3;stroke-miterlimit:10;}\n\t.st13{opacity:0.2;fill:#231F20;}\n\t.st14{fill:#BBBDBF;}\n\t.st15{fill:#DDDEDF;}\n\t.st16{fill:#906548;}\n\t.st17{fill:#B58E64;}\n\t.st18{fill:#896642;}\n\t.st19{fill:#A87C4F;stroke:#6A4D32;stroke-width:3;stroke-miterlimit:10;}\n\t.st20{fill:#D0D2D3;stroke:#9FA1A3;stroke-width:3;stroke-miterlimit:10;}\n\t.st21{fill:#A5F1E9;}\n\t.st22{fill:#8CB347;}\n\t.st23{fill:#603E2A;}\n\t.st24{fill:none;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\n\t.st25{fill:#231F20;}\n\t.st26{fill:#8A5D3B;}\n\t.st27{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850.1,
    y: 799.01,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 859.4506 -355.9229)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1291.7,
    y: 1194.04,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1300.9127 -538.8948)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1076.39,
    y: 1000.39,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1082.9539 -450.8105)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 962.26,
    y: 911.17,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 971.6105 -402.381)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.41,
    y: 948.91,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1027.6637 -425.6746)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.33,
    y: 1055.17,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1140.3379 -470.8911)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.58,
    y: 1151.58,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1252.0458 -518.4404)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.18,
    y: 855.09,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 915.5305 -379.1519)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.41,
    y: 1101.89,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1196.0035 -495.1204)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.12,
    y: 679.12,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -435.4943 1051.382)",
    className: "st17",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.34,
    y: 702.38,
    transform: "matrix(0.6428 -0.766 0.766 0.6428 -380.1828 1239.1595)",
    className: "st17",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.98,
    y: 813.75,
    transform: "matrix(-0.766 0.6428 -0.6428 -0.766 2546.0227 1350.52)",
    className: "st17",
    width: 18.52,
    height: 649.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850.1,
    y: 799.01,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 859.4506 -355.9229)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1291.7,
    y: 1194.04,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1300.9127 -538.8948)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1076.39,
    y: 1000.39,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1082.9539 -450.8105)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 962.26,
    y: 911.17,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 971.6105 -402.381)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.41,
    y: 948.91,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1027.6637 -425.6746)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.33,
    y: 1055.17,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1140.3379 -470.8911)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.58,
    y: 1151.58,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1252.0458 -518.4404)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.18,
    y: 855.09,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 915.5305 -379.1519)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.41,
    y: 1101.89,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 1196.0035 -495.1204)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.12,
    y: 679.12,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -435.4943 1051.382)",
    className: "st11",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.34,
    y: 702.38,
    transform: "matrix(0.6428 -0.766 0.766 0.6428 -380.1828 1239.1595)",
    className: "st11",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.98,
    y: 813.75,
    transform: "matrix(-0.766 0.6428 -0.6428 -0.766 2546.0227 1350.52)",
    className: "st11",
    width: 18.52,
    height: 649.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 631.25,
    y: 798.89,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1701.0806 1014.122)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.84,
    y: 1194.11,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1259.8099 2080.0977)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.9,
    y: 1004.21,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1481.5199 1557.6492)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.09,
    y: 911.05,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1588.9207 1284.8999)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.08,
    y: 948.92,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1532.9965 1420.3534)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.67,
    y: 1052.69,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1417.839 1689.8896)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.6,
    y: 1151.28,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1308.3132 1961.7588)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.17,
    y: 854.97,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1645.0006 1149.511)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.59,
    y: 1101.41,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1364.1737 1826.2788)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.36,
    y: 679.12,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 874.8399 -9.2758)",
    className: "st17",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.51,
    y: 813.76,
    transform: "matrix(0.766 0.6428 -0.6428 0.766 842.489 -37.5028)",
    className: "st17",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.14,
    y: 702.39,
    transform: "matrix(-0.6428 -0.766 0.766 -0.6428 -193.2127 1964.3849)",
    className: "st17",
    width: 18.52,
    height: 649.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 631.25,
    y: 798.89,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1701.0806 1014.122)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.84,
    y: 1194.11,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1259.8099 2080.0977)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.9,
    y: 1004.21,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1481.5199 1557.6492)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.09,
    y: 911.05,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1588.9207 1284.8999)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.08,
    y: 948.92,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1532.9965 1420.3534)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.67,
    y: 1052.69,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1417.839 1689.8896)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.6,
    y: 1151.28,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1308.3132 1961.7588)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.17,
    y: 854.97,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1645.0006 1149.511)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.59,
    y: 1101.41,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1364.1737 1826.2788)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.36,
    y: 679.12,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 874.8399 -9.2758)",
    className: "st11",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.51,
    y: 813.76,
    transform: "matrix(0.766 0.6428 -0.6428 0.766 842.489 -37.5028)",
    className: "st11",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.14,
    y: 702.39,
    transform: "matrix(-0.6428 -0.766 0.766 -0.6428 -193.2127 1964.3849)",
    className: "st11",
    width: 18.52,
    height: 649.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 631.25,
    y: 580.16,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 640.4146 1546.5522)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.84,
    y: 92.19,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 199.144 480.5765)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.9,
    y: 332.91,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 420.8539 1003.0251)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.09,
    y: 468,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 528.2546 1275.7743)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.08,
    y: 393.59,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 472.3305 1140.3208)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.67,
    y: 275.52,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 357.173 870.7845)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.6,
    y: 147.61,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 247.6473 598.9155)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.17,
    y: 524.08,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 584.3346 1411.1632)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.59,
    y: 210.08,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 303.5077 734.3954)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.36,
    y: 76.36,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -185.8261 448.618)",
    className: "st17",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.51,
    y: 36.55,
    transform: "matrix(0.766 -0.6428 0.6428 0.766 -121.6986 388.4387)",
    className: "st17",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.14,
    y: 147.92,
    transform: "matrix(-0.6428 0.766 -0.766 -0.6428 955.8596 499.8108)",
    className: "st17",
    width: 18.52,
    height: 649.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 631.25,
    y: 580.16,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 640.4146 1546.5522)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.84,
    y: 92.19,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 199.144 480.5765)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.9,
    y: 332.91,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 420.8539 1003.0251)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.09,
    y: 468,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 528.2546 1275.7743)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.08,
    y: 393.59,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 472.3305 1140.3208)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.67,
    y: 275.52,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 357.173 870.7845)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.6,
    y: 147.61,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 247.6473 598.9155)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.17,
    y: 524.08,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 584.3346 1411.1632)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.59,
    y: 210.08,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 303.5077 734.3954)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.36,
    y: 76.36,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -185.8261 448.618)",
    className: "st11",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.51,
    y: 36.55,
    transform: "matrix(0.766 -0.6428 0.6428 0.766 -121.6986 388.4387)",
    className: "st11",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.14,
    y: 147.92,
    transform: "matrix(-0.6428 0.766 -0.766 -0.6428 955.8596 499.8108)",
    className: "st11",
    width: 18.52,
    height: 649.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850.1,
    y: 580.02,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -201.2038 795.2603)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1291.7,
    y: 92.24,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 240.2584 978.2322)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1076.39,
    y: 336.71,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 22.2994 890.1479)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 962.26,
    y: 467.86,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -89.0439 841.7184)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.41,
    y: 393.58,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -32.9907 865.0121)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.33,
    y: 273.03,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 79.6835 910.2285)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.58,
    y: 147.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 191.3914 957.7778)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.18,
    y: 523.94,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -145.1238 818.4894)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.41,
    y: 209.59,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 135.3492 934.4578)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.12,
    y: 76.35,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 625.1601 -612.0446)",
    className: "st17",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.34,
    y: 147.91,
    transform: "matrix(0.6428 0.766 -0.766 0.6428 768.8768 -703.3447)",
    className: "st17",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.98,
    y: 36.54,
    transform: "matrix(-0.766 -0.6428 0.6428 -0.766 1581.8458 1298.5315)",
    className: "st17",
    width: 18.52,
    height: 649.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850.1,
    y: 580.02,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -201.2038 795.2603)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1291.7,
    y: 92.24,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 240.2584 978.2322)",
    className: "st16",
    width: 18.52,
    height: 213.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1076.39,
    y: 336.71,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 22.2994 890.1479)",
    className: "st16",
    width: 18.52,
    height: 162.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 962.26,
    y: 467.86,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -89.0439 841.7184)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.41,
    y: 393.58,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -32.9907 865.0121)",
    className: "st16",
    width: 18.52,
    height: 157.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.33,
    y: 273.03,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 79.6835 910.2285)",
    className: "st16",
    width: 18.52,
    height: 171.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.58,
    y: 147.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 191.3914 957.7778)",
    className: "st16",
    width: 18.52,
    height: 201.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.18,
    y: 523.94,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -145.1238 818.4894)",
    className: "st16",
    width: 18.52,
    height: 120.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.41,
    y: 209.59,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 135.3492 934.4578)",
    className: "st16",
    width: 18.52,
    height: 188.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.12,
    y: 76.35,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 625.1601 -612.0446)",
    className: "st11",
    width: 18.52,
    height: 744.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.34,
    y: 147.91,
    transform: "matrix(0.6428 0.766 -0.766 0.6428 768.8768 -703.3447)",
    className: "st11",
    width: 18.52,
    height: 649.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.98,
    y: 36.54,
    transform: "matrix(-0.766 -0.6428 0.6428 -0.766 1581.8458 1298.5315)",
    className: "st11",
    width: 18.52,
    height: 649.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 750,
    cy: 741.86,
    r: 64.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 750,
    cy: 741.86,
    r: 45.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 750,
    cy: 741.86,
    r: 21.16
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPortfolio03);
export default __webpack_public_path__ + "static/media/vector-portfolio-03.ff1f63babdbd082d99dcf3ecb6cb9efe.svg";
export { ForwardRef as ReactComponent };